(function () {
  'use strict';

  if (!document.querySelector('.bk-workshop, .bk-selector')) return;

  const cfg = window.RSBreakup || {};
  const html = document.documentElement;

  const SWEET_RE  = /sweet|angel|side\s*a/i;
  const SNARKY_RE = /snark|devil|side\s*b/i;

  function detectInitialVibe() {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    if (variantId && cfg.variants) {
      const v = cfg.variants.find(x => String(x.id) === String(variantId));
      if (v && SNARKY_RE.test(v.title)) return 'snarky';
      if (v && SWEET_RE.test(v.title))  return 'sweet';
    }
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      const r = form.querySelector('input[type="radio"]:checked');
      if (r) {
        const labelEl = form.querySelector('label[for="' + r.id + '"]');
        const t = (labelEl ? labelEl.textContent : r.value) || '';
        if (SNARKY_RE.test(t)) return 'snarky';
        if (SWEET_RE.test(t))  return 'sweet';
      }
      const sel = form.querySelector('select[name="id"], select[name^="options"]');
      if (sel && sel.selectedOptions[0]) {
        const t = sel.selectedOptions[0].text || '';
        if (SNARKY_RE.test(t)) return 'snarky';
        if (SWEET_RE.test(t))  return 'sweet';
      }
    }
    return 'sweet';
  }

  function setVibe(vibe, opts) {
    if (vibe !== 'sweet' && vibe !== 'snarky') return;
    opts = opts || {};
    html.setAttribute('data-vibe', vibe);
    document.querySelectorAll('[data-set-vibe]').forEach(el => {
      el.setAttribute('aria-pressed', el.dataset.setVibe === vibe);
    });
    const cap = vibe === 'sweet' ? 'Sweet' : 'Snarky';
    document.querySelectorAll('[data-vibe-word]').forEach(el => { el.textContent = cap; });
    // Inline flip control offers the OTHER side (the one not currently shown).
    const otherVibe = vibe === 'sweet' ? 'snarky' : 'sweet';
    const otherCap  = vibe === 'sweet' ? 'Snarky' : 'Sweet';
    document.querySelectorAll('[data-vibe-flip]').forEach(el => {
      el.dataset.flipTo = otherVibe;
      const w = el.querySelector('[data-vibe-flip-word]');
      if (w) w.textContent = otherCap;
    });
    fillChips(vibe);
    const acc = document.querySelector('[data-workshop-accent]');
    if (acc) acc.textContent = vibe === 'sweet'
      ? (cfg.accent_sweet  || 'Three soft ones.')
      : (cfg.accent_snarky || 'One terrible joke.');
    if (!opts.fromForm) syncVariantSelector(vibe);
  }

  function syncVariantSelector(vibe) {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const radios = form.querySelectorAll('input[type="radio"]');
    let hit = null;
    radios.forEach(r => {
      const label = form.querySelector('label[for="' + r.id + '"]');
      const text  = (label ? label.textContent : r.value) || '';
      if (vibe === 'sweet'  && SWEET_RE.test(text))  hit = r;
      if (vibe === 'snarky' && SNARKY_RE.test(text)) hit = r;
    });
    if (hit && !hit.checked) {
      hit.checked = true;
      hit.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const sel = form.querySelector('select[name="id"], select[name^="options"]');
    if (sel) {
      for (const opt of sel.options) {
        if (vibe === 'sweet'  && SWEET_RE.test(opt.text))  { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
        if (vibe === 'snarky' && SNARKY_RE.test(opt.text)) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
      }
    }
  }

  function currentVariantId() {
    if (cfg.variants && cfg.variants.length) {
      const vibe = html.getAttribute('data-vibe') || 'sweet';
      const m = cfg.variants.find(v => (vibe === 'snarky' ? SNARKY_RE : SWEET_RE).test(v.title));
      if (m) return m.id;
    }
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    const hid = form.querySelector('input[name="id"]');
    if (hid && hid.value) return hid.value;
    const sel = form.querySelector('select[name="id"]');
    if (sel && sel.value) return sel.value;
    return null;
  }

  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('change', () => {
      const v = detectInitialVibe();
      if (v !== html.getAttribute('data-vibe')) setVibe(v, { fromForm: true });
    });
  }

  document.querySelectorAll('[data-set-vibe]').forEach(el => {
    el.addEventListener('click', () => {
      if (el.classList.contains('bk-send-btn')) return;
      setVibe(el.dataset.setVibe);
      // Gentle nudge down so the matching items below come into view -
      // makes the tap feel like it did something (the selection sits just below).
      var reveal = document.querySelector('.bk-items');
      if (reveal) {
        var target = reveal.getBoundingClientRect().top + window.pageYOffset - 90;
        if (window.pageYOffset < target - 20) {
          window.scrollTo({ top: target, behavior: 'smooth' });
        }
      }
    });
  });

  // Inline flip in the "Tuned [vibe]" heading - switches the vibe in place,
  // keeps the top toggle + sticky bar in sync (via setVibe), and does NOT scroll.
  document.querySelectorAll('[data-vibe-flip]').forEach(el => {
    el.addEventListener('click', () => {
      const to = el.dataset.flipTo || (html.getAttribute('data-vibe') === 'sweet' ? 'snarky' : 'sweet');
      setVibe(to);
    });
  });

  const EXAMPLES = cfg.examples || {
    tattoo: { sweet: ['Be Well','Stay Kind','Breathe','Soft Power'], snarky: ['Delete Him','His Loss','Move Along','Next'] },
    sound:  { sweet: ["I'm proud of you.","Your feelings are valid.","Take a deep breath.","Tomorrow is new."],
              snarky: ["He's a walking red flag.","Was that supposed to hurt?","Bye bye, problem person.","Plot twist \u2014 you're the catch."] },
    card:   { sweet: ["Saw this and thought of you. Here whenever you need to talk. \u2014 Mom",
                      "Hard week. Soft basket. Love you. \u2014 Sam",
                      "You don't have to be okay yet. Take your time. \u2014 Dani"],
              snarky: ["His texts are not it. You are. \u2014 Jess",
                       "Throw the whole man away. Love, the group chat.",
                       "Plot twist: still the catch. \u2014 Yourself, probably"] }
  };

  function fillChips(vibe) {
    ['tattoo','sound','card'].forEach(addon => {
      const wrap = document.querySelector('[data-chips="' + addon + '"]');
      if (!wrap) return;
      wrap.querySelectorAll('.bk-chip').forEach(c => c.remove());
      (EXAMPLES[addon][vibe] || []).forEach(ex => {
        // Tattoo words show as "Capital then lower" (Title Case); sentences stay as written.
        const label = (addon === 'tattoo')
          ? ex.replace(/\S+/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); })
          : ex;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bk-chip';
        b.textContent = label;
        b.addEventListener('click', () => fillInput(addon, label));
        wrap.appendChild(b);
      });
    });
  }

  const INPUT_IDS = { tattoo: 'bkTtInput', sound: 'bkSbInput', card: 'bkCdInput' };
  function fillInput(addon, value) {
    const input = document.getElementById(INPUT_IDS[addon]);
    if (!input) return;
    const v = addon === 'tattoo' ? value.slice(0, 20) : value;
    input.value = v;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  }

  const ttInput = document.getElementById('bkTtInput');
  if (ttInput) {
    const ttMsg   = document.getElementById('bkTtMsg');
    const ttCount = document.getElementById('bkTtCount');
    function ttScale(len){
      if (len <= 8) return 1;
      if (len <= 12) return 0.92;
      if (len <= 16) return 0.82;
      return 0.74;
    }
    function ttRender(v) {
      const display = v.trim()
        ? v.replace(/\S+/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); })
        : 'Your Message';
      if (ttMsg) {
        ttMsg.textContent = display;
        ttMsg.style.setProperty('--tt-scale', ttScale(display.length));
        ttMsg.classList.toggle('is-placeholder', !v.trim());
      }
      if (ttCount) {
        ttCount.textContent = v.length;
        if (ttCount.parentElement) ttCount.parentElement.classList.toggle('is-warn', v.length >= 18);
      }
    }
    ttInput.addEventListener('input', () => ttRender(ttInput.value));
    ttRender(ttInput.value);
  }

  const sbInput = document.getElementById('bkSbInput');
  if (sbInput) {
    const sbCount   = document.getElementById('bkSbCount');
    const sbCaption = document.getElementById('bkSbCaption');
    const sbStage   = document.getElementById('bkSbStage');
    const sbDevice  = document.getElementById('bkSbDevice');
    const sbBars    = document.querySelectorAll('#bkSbWaveform .bk-sb-bar');
    sbInput.addEventListener('input', () => {
      const v = sbInput.value;
      sbCount.textContent = v.length;
      sbCount.parentElement.classList.toggle('is-warn', v.length >= 55);
      sbCaption.textContent = v || '(your sentence, on demand)';
      sbStage.classList.toggle('is-empty', !v.trim());
      const visible = v.trim() ? Math.max(1, Math.ceil((v.length / 60) * sbBars.length)) : 0;
      sbBars.forEach((b, i) => b.classList.toggle('is-active', i < visible));
    });
    let sbTimer = null;
    sbDevice.addEventListener('click', () => {
      if (sbStage.classList.contains('is-empty')) { sbInput.focus(); return; }
      if (sbStage.classList.contains('is-playing')) return;
      sbStage.classList.add('is-playing');
      sbDevice.classList.add('is-playing');
      clearTimeout(sbTimer);

      var stop = function () {
        sbStage.classList.remove('is-playing');
        sbDevice.classList.remove('is-playing');
      };
      var spoke = false;
      try {
        if ('speechSynthesis' in window) {
          window.speechSynthesis.cancel();
          var u = new SpeechSynthesisUtterance(sbInput.value.trim());
          u.rate = 0.98;
          u.onend = stop;
          u.onerror = stop;
          window.speechSynthesis.speak(u);
          spoke = true;
        }
      } catch (e) { spoke = false; }

      sbTimer = setTimeout(stop, spoke ? 6000 : 2400);
    });
  }

  const cdInput = document.getElementById('bkCdInput');
  if (cdInput) {
    const cdCount  = document.getElementById('bkCdCount');
    const cdLetter = document.getElementById('bkCdLetter');
    cdInput.addEventListener('input', () => {
      const v = cdInput.value;
      cdCount.textContent = v.length;
      cdCount.parentElement.classList.toggle('is-warn', v.length >= 190);
      cdLetter.textContent = v;
      cdLetter.classList.toggle('is-empty', !v.trim());
    });
  }

  const addons = { tattoo: false, sound: false, card: false };
  const BENCH_ID = { tattoo: 'bkBenchTattoo', sound: 'bkBenchSound', card: 'bkBenchCard' };
  const BASE         = (cfg.base_price   != null ? cfg.base_price   : 7495) / 100;
  const ADDON        = (cfg.addon_price  != null ? cfg.addon_price  : 995)  / 100;
  const BUNDLE_PRICE = (cfg.bundle_price != null ? cfg.bundle_price : 2495) / 100;

  function setAddonState(key, on) {
    addons[key] = on;
    const bench = document.getElementById(BENCH_ID[key]);
    if (bench) bench.classList.toggle('is-on', on);
    const btn = document.querySelector('[data-addon-toggle="' + key + '"]');
    if (btn) {
      const t = btn.querySelector('.add-text');
      if (t) t.textContent = on ? 'Added \u00b7 remove' : 'Add \u00b7 $' + ADDON.toFixed(2);
    }
    recalcTotal();
    updateCounter();
  }

  document.querySelectorAll('[data-addon-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.addonToggle;
      setAddonState(key, !addons[key]);
    });
  });

  function updateCounter() {
    const on = Object.entries(addons).filter(([, v]) => v).map(([k]) => k);
    const cEl = document.getElementById('bkAddOnCount');
    if (cEl) cEl.textContent = on.length;
    const extra = on.length === 3 ? BUNDLE_PRICE : on.length * ADDON;
    const xEl = document.getElementById('bkAddOnExtra');
    if (xEl) xEl.textContent = '+ $' + extra.toFixed(2);
    document.querySelectorAll('.pc-dot').forEach(d => {
      d.classList.toggle('is-on', addons[d.dataset.dot]);
    });
    const pct = (on.length / 3) * 100;
    const prog = document.getElementById('bkBundleProgress');
    if (prog) prog.style.width = pct + '%';
    const status = document.getElementById('bkBundleStatus');
    const btn = document.getElementById('bkBundleBtn');
    if (status && btn) {
      if (on.length === 0) {
        status.textContent = 'Add all three and save $4.90.';
        status.classList.remove('is-unlocked');
        btn.classList.remove('is-unlocked');
        btn.textContent = 'Add the bundle';
      } else if (on.length === 1) {
        status.textContent = 'Two more to save $4.90';
        status.classList.remove('is-unlocked');
        btn.classList.remove('is-unlocked');
        btn.textContent = 'Add the rest';
      } else if (on.length === 2) {
        status.textContent = 'One more \u2014 $4.90 unlocks';
        status.classList.remove('is-unlocked');
        btn.classList.remove('is-unlocked');
        btn.textContent = 'Add the rest';
      } else {
        status.textContent = 'Bundle unlocked \u2014 $4.90 saved';
        status.classList.add('is-unlocked');
        btn.classList.add('is-unlocked');
        btn.textContent = 'Remove the bundle';
      }
    }
  }

  function recalcTotal() {
    let total = BASE;
    const onCount = Object.values(addons).filter(Boolean).length;
    if (onCount === 3) total += BUNDLE_PRICE; else total += onCount * ADDON;
    const fmt = total.toFixed(2);
    document.querySelectorAll('[data-send-total]').forEach(el => el.textContent = fmt);
    const sb = document.getElementById('rsSbPrice');
    if (sb) sb.textContent = '$' + fmt;
  }

  const bundleBtn = document.getElementById('bkBundleBtn');
  if (bundleBtn) {
    bundleBtn.addEventListener('click', () => {
      const allOn = addons.tattoo && addons.sound && addons.card;
      ['tattoo','sound','card'].forEach(k => setAddonState(k, !allOn));
    });
  }

  const addonVariants = cfg.addon_variants || {};
  const propKey = cfg.property_key_text || 'Custom message';

  function readAddonText(key) {
    const id = INPUT_IDS[key];
    const el = id ? document.getElementById(id) : null;
    return el ? el.value.trim() : '';
  }

  async function send(vibe) {
    setVibe(vibe);
    const variantId = currentVariantId();
    if (!variantId) { alert('Pick a vibe first.'); return; }

    // Personalization is required whenever an add-on is selected - never let a
    // blank tattoo / sound button, or a card with no name or no message, go through.
    if (addons.tattoo && addonVariants.tattoo) {
      const el = document.getElementById('bkTtInput');
      if (!el || !el.value.trim()) {
        alert('The tattoo needs its words first. Add what they\u2019ll wear, then send.');
        if (el) { el.focus(); el.scrollIntoView({ block: 'center' }); }
        return;
      }
    }
    if (addons.sound && addonVariants.sound) {
      const el = document.getElementById('bkSbInput');
      if (!el || !el.value.trim()) {
        alert('The sound button needs something to say. Add a line, then send.');
        if (el) { el.focus(); el.scrollIntoView({ block: 'center' }); }
        return;
      }
    }
    if (addons.card && addonVariants.card) {
      const nameEl = document.getElementById('bkCdName');
      const msgEl  = document.getElementById('bkCdMsg');
      const nm  = nameEl ? nameEl.value.trim() : '';
      const msg = msgEl  ? msgEl.value.trim()  : '';
      if (!nm) {
        alert('Who\u2019s the keepsake card for? Add their name first.');
        if (nameEl) { nameEl.focus(); nameEl.scrollIntoView({ block: 'center' }); }
        return;
      }
      if (!msg) {
        alert('We don\u2019t send blank cards. Add a short message for the inside.');
        if (msgEl) { msgEl.focus(); msgEl.scrollIntoView({ block: 'center' }); }
        return;
      }
    }

    const items = [{ id: Number(variantId), quantity: 1 }];

    ['tattoo','sound','card'].forEach(k => {
      if (!addons[k]) return;
      const vid = addonVariants[k];
      if (!vid) return;
      let text = readAddonText(k);
      if (k === 'tattoo' && text) {
        text = text.replace(/\S+/g, function(w){ return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); });
      }
      const props = text ? { [propKey]: text } : {};
      if (k === 'tattoo') {
        props['Vibe'] = (html.getAttribute('data-vibe') === 'snarky') ? 'Snarky' : 'Sweet';
      }
      if (k === 'card') {
        const nameEl = document.getElementById('bkCdName');
        const fromEl = document.getElementById('bkCdFrom');
        const msgEl  = document.getElementById('bkCdMsg');
        const nm = nameEl ? nameEl.value.trim() : '';
        const fr = fromEl ? fromEl.value.trim() : '';
        const ms = msgEl ? msgEl.value.trim() : '';
        if (nm) props['Their name'] = nm;
        if (fr) props['From'] = fr;
        if (ms) props['Message'] = ms;
        props['Vibe'] = (html.getAttribute('data-vibe') === 'snarky') ? 'Snarky' : 'Sweet';
      }
      items.push({ id: Number(vid), quantity: 1, properties: props });
    });

    document.querySelectorAll('.bk-send-btn').forEach(b => b.disabled = true);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Cart add failed (' + res.status + ')');
      const drawer = document.querySelector('cart-drawer, [data-cart-drawer], #cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        drawer.show();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:update'));
        window.location.href = '/cart';
      }
    } catch (err) {
      console.error('[RSBreakup] send failed', err);
      alert('Sorry \u2014 something went wrong adding to cart. Try again?');
    } finally {
      document.querySelectorAll('.bk-send-btn').forEach(b => b.disabled = false);
    }
  }

  document.querySelectorAll('.bk-send-btn').forEach(btn => {
    btn.addEventListener('click', () => send(btn.dataset.setVibe));
  });

  const sbCta = document.getElementById('rsSbCta');
  if (sbCta) {
    sbCta.addEventListener('click', e => {
      e.preventDefault();
      send(html.getAttribute('data-vibe') || 'sweet');
    });
  }

  setVibe(detectInitialVibe(), { fromForm: true });
  fillChips(html.getAttribute('data-vibe'));
  updateCounter();
  recalcTotal();

  // ---- Gentle "still here when you're ready" nudge ----
  // Fires once per visit after the shopper has fiddled with the personalization
  // a bunch of times without adding anything. Never fires once they hit Send.
  (function initNudge(){
    var station = document.getElementById('bkTtInput') || document.getElementById('bkCdName') || document.querySelector('.bk-send-btn');
    if (!station) return;
    try { if (sessionStorage.getItem('rsNudgeSeen') === '1') return; } catch (e) {}

    var THRESHOLD = 8, fiddles = 0, done = false, counted = {};

    var css = '.rsn-nudge{position:fixed;left:50%;bottom:22px;transform:translate(-50%,150%);width:min(440px,calc(100vw - 32px));background:#F4EFE6;border:1px solid #E3D9C8;border-radius:18px;box-shadow:0 18px 50px rgba(26,16,8,.22);padding:22px 22px 20px;z-index:9000;opacity:0;pointer-events:none;transition:transform .5s cubic-bezier(.2,.8,.2,1),opacity .4s ease;font-family:"Nunito",system-ui,sans-serif;}'
      + '.rsn-nudge.rsn-show{transform:translate(-50%,0);opacity:1;pointer-events:auto;}'
      + '.rsn-close{position:absolute;top:12px;right:14px;border:0;background:none;font-size:20px;color:#8B7C6A;cursor:pointer;line-height:1;}'
      + '.rsn-eyebrow{font-size:11px;font-weight:800;letter-spacing:.16em;text-transform:uppercase;color:#8B7C6A;}'
      + '.rsn-hand{font-family:"Caveat",cursive;font-weight:700;color:#C19858;font-size:30px;line-height:1;margin:4px 0 8px;}'
      + '.rsn-body{margin:0 0 16px;font-size:14.5px;line-height:1.5;color:#5C4F40;}'
      + '.rsn-acts{display:flex;gap:10px;align-items:center;}'
      + '.rsn-go{border:0;border-radius:99px;background:#1A1008;color:#fff;font-weight:800;font-size:14px;padding:12px 18px;cursor:pointer;}'
      + '.rsn-later{border:0;background:none;color:#8B7C6A;font-size:13px;font-weight:700;cursor:pointer;text-decoration:underline;text-underline-offset:3px;}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

    var nudge = document.createElement('div');
    nudge.className = 'rsn-nudge';
    nudge.setAttribute('role', 'dialog');
    nudge.setAttribute('aria-label', 'A gentle note');
    nudge.innerHTML = '<button class="rsn-close" type="button" aria-label="Close">\u00d7</button>'
      + '<span class="rsn-eyebrow">No pressure</span>'
      + '<div class="rsn-hand">Take your time.</div>'
      + '<p class="rsn-body">You\u2019ve clearly got someone in mind. Pick a side when you\u2019re ready, and we\u2019ll hand-pack it and get it out the door within 24 hours.</p>'
      + '<div class="rsn-acts"><button class="rsn-go" type="button">Take me to Send \u2192</button><button class="rsn-later" type="button">I\u2019m still looking</button></div>';
    document.body.appendChild(nudge);

    function seen(){ try { sessionStorage.setItem('rsNudgeSeen', '1'); } catch (e) {} }
    function show(){ if (done) return; done = true; seen(); nudge.classList.add('rsn-show'); }
    function hide(){ nudge.classList.remove('rsn-show'); }
    function convert(){ done = true; seen(); hide(); }
    // A "fiddle" = one deliberate interaction: a vibe flip, an add-on toggle, or a
    // burst of typing in a field. After THRESHOLD of them with nothing added, nudge.
    function bump(){ if (done) return; fiddles++; if (fiddles >= THRESHOLD) show(); }

    document.addEventListener('click', function (e) {
      if (done) return;
      if (e.target.closest('.bk-send-btn, #rsSbCta')) { convert(); return; }
      if (e.target.closest('[data-set-vibe]:not(.bk-send-btn), [data-vibe-flip], [data-addon-toggle]')) bump();
    }, true);
    ['bkTtInput','bkSbInput','bkCdName','bkCdFrom','bkCdMsg'].forEach(function (id) {
      var el = document.getElementById(id); if (!el) return;
      var deb;
      el.addEventListener('input', function () {
        clearTimeout(deb);
        deb = setTimeout(function () { if (!counted[id] && el.value.trim()) { counted[id] = true; bump(); } }, 450);
      });
    });
    nudge.querySelector('.rsn-close').addEventListener('click', hide);
    nudge.querySelector('.rsn-later').addEventListener('click', hide);
    nudge.querySelector('.rsn-go').addEventListener('click', function () {
      hide();
      var send = document.querySelector('.bk-send');
      if (send) { window.scrollTo({ top: send.getBoundingClientRect().top + window.pageYOffset - 40, behavior: 'smooth' }); }
    });
  })();
})();